
import { defineComponent } from 'vue';
import { connectionToastState } from '@/services/connectionMonitor';

export default defineComponent({
  name: 'ConnectionStatusToast',
  setup() {
    return {
      toast: connectionToastState,
    };
  },
});
